/**
 * 수정자 : 박승호
 * 날짜 : 2024.09.06
 * 수정 : format, minValue 추가
 */

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ButtonContainer from '../../s_cctv/S_cctv1/RealtimeCCTV/ButtonContainer';
import ClickableContainer from '../../s_cctv/S_cctv1/RealtimeCCTV/ClickableContainer';

interface StyleProps {
  maxWidth: string;
}

const Root = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  max-width: ${(props: StyleProps) => props.maxWidth};

  input[type='range'] {
    padding: 0 !important;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      font-size: 0.875rem;
      color: var(--text-secondary);
      font-weight: 600;
    }
    .control-container {
      display: flex;
      align-items: center;
      .value-wrapper {
        font-size: 0.875rem;
        min-width: 2.5rem;
        display: flex;
        justify-content: center;
        margin: 0 0.5rem;
        color: var(--text-disabled);
        .value {
          font-weight: 600;
          font-size: 1rem;
          color: var(--text-secondary);
          margin-right: 0.125rem;
        }
      }
    }
  }
  input {
    padding: 0 !important;
    height: 2.5rem;
    &:focus {
      outline: none;
    }
  }
`;

interface Props {
  handleSlider: (e: React.ChangeEvent<HTMLInputElement>, dataKey: string) => void;
  dataKey: string;
  data: string;
  labelName: string;
  format?: string;
  minValue: number;
  maxValue: number;
  maxWidth: string;
  disabled?: boolean;
}

const SliderSettings = ({ handleSlider, dataKey, data, labelName, format, minValue, maxValue, maxWidth, disabled = false }: Props) => {
  const { t } = useTranslation();

  const handleIncrement = () => {
    if (Number(data) < maxValue) {
      const event = { target: { value: Number(data) + 1 } } as unknown;
      handleSlider(event as React.ChangeEvent<HTMLInputElement>, dataKey);
    }
  };

  const handleDecrement = () => {
    if (Number(data) > minValue) {
      const event = { target: { value: Number(data) - 1 } } as unknown;
      handleSlider(event as React.ChangeEvent<HTMLInputElement>, dataKey);
    }
  };

  return (
    <Root maxWidth={maxWidth}>
      <div className='header'>
        <span className='label'>{t(labelName)}</span>
        <div className='control-container'>
          <ClickableContainer
            button={<ButtonContainer icon='remove' />} //
            onClick={handleDecrement}
            disabled={Number(data) === Number(minValue) || disabled}
          />
          <span className='value-wrapper'>
            <span className='value'>{data}</span>
            {format && format}
          </span>
          <ClickableContainer
            button={<ButtonContainer icon='add' />} //
            onClick={handleIncrement}
            disabled={Number(data) === Number(maxValue) || disabled}
          />
        </div>
      </div>
      <input
        type='range' // 슬라이더 타입
        min={minValue.toString()} // 최소값
        max={maxValue.toString()} // 최대값
        step='1' // 슬라이더 값 변경 단위
        value={data} // 슬라이더 값
        onChange={(e) => handleSlider(e, dataKey)} // 슬라이더 값 변경 이벤트
        disabled={disabled}
      />
    </Root>
  );
};

export default SliderSettings;
